import { useLoader as _useLoader } from '@btime/react-contexts'

import { defaultLoaderRender } from './defaultLoaderRender'

export const useLoader = (fetchData, watch) => {
  const renderParams = _useLoader(fetchData, watch)
  return { render: defaultLoaderRender(renderParams), ...renderParams }
}
